module.exports = __webpack_public_path__ + "img/pr-11.375c5a38.png";